<!-- <app-header></app-header> -->

<section class="ftco-section">
    <div class="container">
        <div class="ftco-search">
            <div class="row">
                <div class="boton_show_categorias col text-center mb-1">
                    <a class="btn btn-sm btn-outline-secondary text-center" (click)="btnShowCategorias()">
                        <!-- <a class="btn btn-sm btn-outline-secondary text-center" data-toggle="collapse" href="#categorias_menu" role="button" aria-expanded="false" aria-controls="categorias_menu"> -->
                        <span *ngIf="!showMenu">Mostrar Categorias <i class="fas fa-chevron-down"></i></span>
                        <span *ngIf="showMenu">Ocultar Categorias <i class="fas fa-chevron-up"></i></span>
                    </a>
                </div>
                <!-- <div class="col-md-12 nav-link-wrap collapse" id="categorias_menu"> -->
                <div class="col-md-12 nav-link-wrap collapse" id="categorias_menu" [ngClass]="{'show' : showMenu}">
                    <div class="nav nav-pills d-flex text-center" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                        <a (click)="selectCategory('all')" href="#" [ngClass]="{'active' : showMenu}" routerLinkActive='active' class="nav-link animate__animated animate__fadeIn" id="all-tab" data-toggle="pill" role="tab" aria-controls="all" aria-selected="true">
                            Todo
                        </a>
                        <a (click)="selectCategory(item.uid)" href="#" [ngClass]="{'active' : !showMenu}" *ngFor="let item of ds_categorias" routerLinkActive='active' class="nav-link animate__animated animate__fadeIn" id="{{item.link}}-tab" data-toggle="pill" role="tab" aria-controls="item.category"
                            aria-selected="true">
                            {{ item.categoria | titlecase }}
                        </a>
                    </div>
                </div>
                <div class="col-md-12 tab-wrap">
                    <div class="tab-content" id="v-pills-tabContent">
                        <div class="tab-pane fade show active" id="kids" role="tabpanel" aria-labelledby="day-1-tab">
                            <div class="row no-gutters d-flex align-items-stretch">
                                <app-menu-item class="col-md-12 col-lg-6 d-flex align-self-stretch" *ngFor="let item of filtro_platillos" [item]="item" [detailUser]="detailUser" [param_code]="param_code"></app-menu-item>
                                <div class="alert alert-info col-12 text-center" role="alert" *ngIf="filtro_platillos?.length <= 0">
                                    No existen platillos para la categoría seleccionada
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<button class="btn btn-sm btn-warning fixed-bottom" (click)="volverArriba()">
    <i class="fas fa-arrow-up"></i> Volver arriba
</button>